"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VERSAO_PESQUISA_PAGINADA = exports.VERSAO_PESQUISA_COMPLETA = void 0;
exports.VERSAO_PESQUISA_COMPLETA = 1;
exports.VERSAO_PESQUISA_PAGINADA = 2;
